// Share
document.addEventListener('DOMContentLoaded', () => {
    const shareButtons = document.querySelectorAll('[data-sharebutton="1"]')
    shareButtons.forEach((button) => {
        if (!navigator.share) {
            return;
        }
        button.classList.remove('d-none')
        button.addEventListener('click', async () => {
            await navigator.share({
                url: window.location.href,
            })
        })
    })
});